module.exports = "<router-outlet></router-outlet>\r\n<app-toast></app-toast>"